/**
 * Cart Module Loader - Minimal Stub
 * Simplified version to prevent module loading errors
 */

// Minimal stub class to prevent instantiation errors
class CartModuleLoader {
  constructor() {
    // Minimal stub constructor
  }
  
  async loadModule() { return null; } 
  async requireModule() { return null; }
  isModuleLoaded() { return false; }
  getLoadingStats() { return { loaded: [], loading: [], capabilities: {}, strategies: {} }; }
}

// Initialize with stub
window.cartModuleLoader = new CartModuleLoader();

// Cart A/B Testing API Proxy - Simplified version
if (!window.CartABTestingAPI) {
  window.CartABTestingAPI = {
    async switchToDrawer() {
      return window.cartABTesting?.switchToDrawer() || null;
    },
    
    async switchToNotification() {
      return window.cartABTesting?.switchToNotification() || null;
    },
    
    async getCurrentType() {
      return window.cartABTesting?.getCurrentCartType() || 'notification';
    },
    
    async getActiveCart() {
      return window.cartABTesting?.getActiveCart() || 
             document.querySelector('cart-notification') || 
             document.querySelector('cart-drawer');
    },
    
    async forceUpdateProductForms() {
      return window.cartABTesting?.forceUpdateProductForms() || null;
    },
    
    async getDebugInfo() {
      return window.cartABTesting?.getDebugInfo() || { message: 'Cart A/B Testing not available' };
    },
    
    loadModule() { return Promise.resolve(null); },
    isLoaded() { return !!window.cartABTesting; }
  };
}

// Sticky Add to Cart API Proxy - Simplified version
if (!window.StickyAddToCartAPI) {
  window.StickyAddToCartAPI = {
    async show() { return window.stickyAddToCart?.show() || null; },
    async hide() { return window.stickyAddToCart?.hide() || null; },
    async toggle() { return window.stickyAddToCart?.toggle() || null; },
    loadModule() { return Promise.resolve(null); },
    isLoaded() { return !!window.stickyAddToCart; }
  };
}

// Status function for checking availability
window.cartModuleLoader.showStats = function() {
  console.group('📦 Cart Module Loader Stats');
  console.log('Status: Minimal stub active');
  console.log('A/B Testing Available:', !!window.cartABTesting);
  console.log('Sticky Add to Cart Available:', !!window.stickyAddToCart);
  console.groupEnd();
};

// Cart Module Loader stub initialized 